/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Salutationinconversation2Inputs */

const de__field_salutationinconversation2 = /** @type {(inputs: _Field_Salutationinconversation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anrede im Gespräch`)
};

/**

* @param {_Field_Salutationinconversation2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_salutationinconversation2 = /** @type {((inputs?: _Field_Salutationinconversation2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Salutationinconversation2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_salutationinconversation2(inputs)
});
export { _field_salutationinconversation2 as "_field_salutationInConversation" }